var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "root", staticClass: "qm-affix", style: _vm.rootStyle },
    [
      _c(
        "div",
        {
          class: { "qm-affix--fixed": _vm.state.fixed },
          style: _vm.affixStyle,
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }